module.exports = __webpack_public_path__ + "img/f280-verified.18a8b924.png";